import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import AddEmail from './AddEmail'
import EmailAddress from './EmailAddress'

import {connect} from '../../../state/hooks/tools'
import {createResource, deleteResource, readEndpoint, updateResource} from '../../../lib/asyncMethods'
import {EMAILS} from '../../../state/actionTypes'
import {PROMOTE, VERIFY, orderedEmails} from '../../../lib/emails'

const EmailManagement = props => {
  const {emails} = props

  const addEmail = address => props.createResource({endpoint: 'emails', attributes: {address}})

  const verifyEmail = ({email, code}) => (
    props.updateResource({endpoint: `emails/${email.id}`, attributes: {action: VERIFY, code}})
  )

  const removeEmail = email => props.deleteResource(`emails/${email.id}`)

  // Promoting demotes the address that held the role, and only the promoted one comes back in the
  // response. Refetching is what keeps the list from showing two primaries until the next visit.
  const promoteEmail = email => (
    props.updateResource({endpoint: `emails/${email.id}`, attributes: {action: PROMOTE}}).then(response => {
      if (response.success)
        props.fetchEmails('emails')

      return response
    })
  )

  return (
    <Stack className='email-management' component='div'>
      <Typography variant='h6' gutterBottom>Emails</Typography>
      <Typography className='caption' variant='body2' gutterBottom>
        Your primary address is where account mail is sent — password resets above all. A second
        address gives you somewhere to fall back on if you lose the first.
      </Typography>
      <Stack className='addresses' component='div'>
        {
          orderedEmails(emails).map(
            email => (
              <EmailAddress
                key={email.id}
                email={email}
                emails={emails}
                loading={props.loading}
                promoteEmail={promoteEmail}
                removeEmail={removeEmail}
                verifyEmail={verifyEmail}
              />
            )
          )
        }
      </Stack>
      <AddEmail addEmail={addEmail} loading={props.loading} />
    </Stack>
  )
}

const mapStateToProps = ({emails}) => ({emails: [], ...emails})

const actionCreators = ({emails}) => ({
  createResource: createResource(emails, EMAILS),
  updateResource: updateResource(emails, EMAILS),
  deleteResource: deleteResource(emails, EMAILS),
  fetchEmails: readEndpoint(emails, EMAILS)
})

export default connect(mapStateToProps, actionCreators)(EmailManagement)
